<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
  Lokationstilknytning
</h2>
<button class="btn-close btn-icon" (click)="close()">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<mat-dialog-content>
  <div class="table-container">
    <table class="table table--center-vert">
      <thead>
        <tr>
          <th class="align-left">Priskilt ID</th>
          <th class="align-left">Note</th>
          <th class="align-left" style="width: 300px">Lokation</th>
          @if (allocatedPriceSign?.relation_identifier) {
            <th style="width: 40px"></th>
          }
        </tr>
      </thead>
      <tbody>
        @if (allocatedPriceSign) {
          <tr>
            <td>{{ allocatedPriceSign.vendor_identifier }}</td>
            <td>{{ allocatedPriceSign.vendor_note }}</td>
            <td>
              @if (typeAheadLocationModel && allocatedPriceSign) {
                <mat-form-field [subscriptSizing]="'dynamic'" class="location-select">
                  <mat-label>Vælg Lokation</mat-label>
                  <div [formGroup]="typeAheadLocationModel">
                    <input
                      type="text"
                      #locationSelect
                      formControlName="typeAheadQuery"
                      [matAutocomplete]="auto"
                      matInput
                      placeholder="Vælg" />
                  </div>
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    hideSingleSelectionIndicator="true"
                    [displayWith]="displayFn"
                    (optionSelected)="editLocation(allocatedPriceSign, $event.option.value)"
                    okCustomDropDownArrowDirective>
                    @for (location of filteredLocations; track location.charging_station_location_identifier) {
                      <mat-option [value]="location">
                        <div class="location-option">
                          <strong>
                            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
                            {{ location.charging_station_location_name }}, {{ location.organization_name }}
                          </strong>
                          <span class="small">
                            {{ location.charging_station_location_name }}, {{ location.charging_station_location_address }}
                          </span>
                        </div>
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-icon matSuffix></mat-icon>
                </mat-form-field>
              }
            </td>
            @if (allocatedPriceSign.relation_identifier) {
              <td>
                <button mat-icon-button title="Slet tilknytning" class="delete" (click)="removeLocation(allocatedPriceSign)">
                  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
                </button>
              </td>
            }
          </tr>
        }
        @for (unallocatedPriceSign of unallocatedPriceSigns$ | async; track unallocatedPriceSign.price_sign_identifier) {
          <tr>
            <td>{{ unallocatedPriceSign.vendor_identifier }}</td>
            <td>{{ unallocatedPriceSign.vendor_note }}</td>
            <td>
              @if (typeAheadLocationModel && !unallocatedPriceSign.allocated_charging_station_location) {
                <mat-form-field [subscriptSizing]="'dynamic'" class="location-select">
                  <mat-label>Vælg Lokation</mat-label>
                  <mat-hint>Listen viser max 100 lokationer - Søg for at filtrere</mat-hint>
                  <div [formGroup]="typeAheadLocationModel">
                    <input
                      type="text"
                      #locationSelect
                      formControlName="typeAheadQuery"
                      [matAutocomplete]="auto"
                      matInput
                      placeholder="Vælg" />
                  </div>
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    hideSingleSelectionIndicator="true"
                    [displayWith]="displayFn"
                    (optionSelected)="createLocation(unallocatedPriceSign, $event.option.value)"
                    okCustomDropDownArrowDirective>
                    @for (location of filteredLocations; track location.charging_station_location_identifier) {
                      <mat-option [value]="location">
                        <div class="location-option">
                          <strong>
                            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
                            {{ location.charging_station_location_name }}, {{ location.organization_name }}
                          </strong>
                          <span class="small">
                            {{ location.charging_station_location_name }}, {{ location.charging_station_location_address }}
                          </span>
                        </div>
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-icon matSuffix></mat-icon>
                </mat-form-field>
              }
              @if (unallocatedPriceSign.allocated_charging_station_location) {
                <div class="flex">
                  <ok-feedback-success>
                    <div>
                      <strong>
                        {{ unallocatedPriceSign.allocated_charging_station_location.charging_station_location_name }}
                      </strong>
                      <div class="flex">
                        {{ unallocatedPriceSign.allocated_charging_station_location.charging_station_location_address }}
                      </div>
                      <div class="tiny-text">
                        {{ unallocatedPriceSign.allocated_charging_station_location.organization_name }}
                      </div>
                    </div>
                  </ok-feedback-success>
                  <button
                    class="btn-icon red margin--left-m delete"
                    [matTooltip]="'Fortryd tilknytning'"
                    (click)="removeLocation(unallocatedPriceSign)">
                    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
                  </button>
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="close()">Luk</button>
</mat-dialog-actions>
